function TerminalScreenshot({ src, alt, caption }) {
  return (
    <div className="max-w-4xl mx-auto px-4">
      <div className="rounded-lg border border-[#AC8E66]/20 overflow-hidden shadow-2xl shadow-black/40">
        <div className="flex items-center gap-2 px-4 py-2 bg-[#1a1a1a] border-b border-[#AC8E66]/10">
          <span className="w-2.5 h-2.5 rounded-full bg-[#ff5f57]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#febc2e]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#28c840]" />
          {caption && <span className="ml-3 text-[10px] text-[#AC8E66]/60 select-none">{caption}</span>}
        </div>
        <img src={src} alt={alt} className="w-full h-auto block" loading="lazy" />
      </div>
    </div>
  );
}

export default TerminalScreenshot;
